import { ArrowsArrowRight } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';
interface Props {
  oldValue: string;
  newValue: string;
}

const useStyles = makeStyles(() =>
  createStyles({
    accountCell: {
      display: 'flex',
      alignItems: 'center',
      '& > svg': {
        width: 10,
        height: 10
      }
    }
  })
);

export const ChangeArrowCell = ({ oldValue, newValue }: Props) => {
  const classes = useStyles();
  return (
    <span className={classes.accountCell}>
      {oldValue}&nbsp;
      <ArrowsArrowRight />
      &nbsp;{newValue}
    </span>
  );
};
